import {
	FormSectionCard,
	GradientText,
	SubmitButton,
	SubmitButtonContainer,
} from '../PasserCommande/PasserCommande.styles'
import Select from 'react-select'
import './Register.css'
import React, { useEffect, useState, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import CommonHeader from '../../Components/CommonHeader/common-header.component'
import { CustomInput } from '../RegisterTransporter/style'
import Footer from '../../Components/Footer/footer.component'
import Modal from 'react-modal'
import UploadFile from '../../Components/UploadSingleFile/upload.component'
import { actions } from '../../redux/user'
import { signup } from '../../api/auth'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import PhoneInput from 'react-phone-input-2'
import { validatePhoneNumber } from '../../utils/phoneValidator'
import { Link } from 'react-router-dom'
import countries from 'i18n-iso-countries'
import fr from 'i18n-iso-countries/langs/fr.json'
import en from 'i18n-iso-countries/langs/en.json'
import { useTranslation } from 'react-i18next'

countries.registerLocale(fr)
countries.registerLocale(en)

Modal.setAppElement('#root')

const MemoizedUploadFile = React.memo(UploadFile)

function SignUp() {
	const history = useHistory()
	const [loading, setLoading] = useState(false)
	const dispatch = useDispatch()

	const [modalIsOpen, setModalIsOpen] = useState(false)
	const { i18n } = useTranslation();

const options = useMemo(() => {
  const countryNames = countries.getNames(i18n.language, {
    select: 'official',
  });

  return Object.entries(countryNames)
    .map(([code, name]) => ({
      value: code,
      label: name,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}, [i18n.language]); 
	const onSubmit = async (data) => {
		try {
			if (data.password !== data.password_verification) {
				toast.error('Veuillez vérifier votre mot de passe', {
					style: {
						fontFamily: 'Montserrat',
					},
				})
				return
			}
			const files = []
			const fileFields = ['kbis', 'piece_identite', 'logo']

			fileFields.forEach((field) => {
				if (data[field]) {
					files.push({
						[field]: data[field],
					})
					delete data[field]
				}
			})
			delete data.logo
			delete data.kbis
			delete data.password_verification
			delete data.acceptTerms
			data.role = 'client'
			let _values = { ...data }

			if (_values.pays.value === 'FR') {
				_values.tva = true
			}

			setLoading(true)

			const res = await signup(_values, files)

			setModalIsOpen(true)
		} catch (error) {
			const data = error?.response?.data?.errors
			if (data?.msg === 'EMAIL_ALREADY_EXISTS') {
				toast.error(
					'Ce mail est déjà utilisé par un autre utilisateur.',
					{
						style: {
							fontFamily: 'Montserrat',
						},
					}
				)
			} else {
				toast.error(
					error.response?.data.error ||
						error.response?.data.message ||
						"Une erreur s'est produite",
					{
						style: {
							fontFamily: 'Montserrat',
						},
					}
				)
			}
		} finally {
			setLoading(false)
		}
	}
	useEffect(() => {
		dispatch(actions.logOut())
	}, [dispatch])

	const {
		handleSubmit,
		control,
		formState: { errors },
		register,
		setValue,
	} = useForm()
	const {t} = useTranslation()
	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth <= 768);
	
	
		useEffect(() => {
			const checkIfMobile = () => {
				setSmallScreen(window.innerWidth <= 768);
			};
			window.addEventListener('resize', checkIfMobile);
	
			return () => window.removeEventListener('resize', checkIfMobile);
		}, []);
	return (
		<>
			<CommonHeader />
			<div className='form-container'>
				<GradientText style={{ textAlign: 'center' ,fontSize: isSmallScreen ? '1.5rem' : '2.5rem', paddingRight: '1rem', paddingLeft:'1rem' }}>
					{t("create_client_account_button").toUpperCase()}
				</GradientText>

				<div className='form-wrapper'>
					<form onSubmit={handleSubmit(onSubmit)}>
						<FormSectionCard>
							<div className='form-row'>
								<div className='form-group'>
									<label htmlFor='societe'>
										{t("company_name")}{' '}
										<span className='required'>*</span>
									</label>
									<CustomInput
										type='text'
										id='societe'
										{...register('societe', {
											required:
												 t("err_message1")+  t("company_name"),
											minLength: {
												value: 3,
												message:t("article_m") +t("company_name") +t("err_message2") ,
											},
											validate: (value) =>
												/[A-Za-z0-9]/.test(value) ||
												t("article_m") + t("company_name_err_message"),
										})}
									/>
									{errors.societe && (
										<div className='error-message'>
											{errors.societe.message}
										</div>
									)}
								</div>
								<div className='form-group'>
									<label htmlFor='siret'>
										SIRET{' '}
										<span className='required'>*</span>
									</label>
									<CustomInput
										type='text'
										id='siret'
										{...register('siret', {
											required:t("err_message1")+  "SIRET",
											pattern: {
												value: /^[0-9]{14}$/,
												message:
													t("siret_err_message"),
											},
										})}
									/>
									{errors.siret && (
										<div className='error-message'>
											{errors.siret.message}
										</div>
									)}
								</div>
							</div>
							<div className='form-row'>
								<div className='form-group'>
									<label htmlFor='last_name'>
										{t("last_name")} <span className='required'>*</span>
									</label>
									<CustomInput
										type='text'
										id='last_name'
										{...register('last_name', {
											required: t("err_message1")+  t("last_name"),
											minLength: {
												value: 3,
												message:t("article_m") +t("last_name") +t("err_message2"),
											},
											pattern: {
												value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
												message: t("article_m") +t("last_name") +t("err_message3"),
											},
										})}
									/>
									{errors.last_name && (
										<div className='error-message'>
											{errors.last_name.message}
										</div>
									)}
								</div>

								<div className='form-group'>
									<label htmlFor='first_name'>
										{t("first_name")}{' '}
										<span className='required'>*</span>
									</label>
									<CustomInput
										type='text'
										id='first_name'
										{...register('first_name', {
											required: t("err_message1")+  t("first_name"),
											minLength: {
												value: 3,
												message:t("article_m") +t("first_name") +t("err_message2"),
											},
											pattern: {
												value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
												message: t("article_m") +t("first_name") +t("err_message3"),
											},
										})}
									/>
									{errors.first_name && (
										<div className='error-message'>
											{errors.first_name.message}
										</div>
									)}
								</div>
							</div>
							<div className='form-row'>
								<div className='form-group'>
									<label htmlFor='quality'>
										{t("quality")}{' '}
										<span className='required'>*</span>
									</label>
									<CustomInput
										type='text'
										id='quality'
										{...register('quality', {
											required: t("err_message1")+ t("quality"),
											minLength: {
												value: 3,
												message: t("article_f") +t("quality") +t("err_message2"),
											},
											pattern: {
												value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
												message: t("article_f") +t("quality") +t("err_message3"),
											},
										})}
									/>
									{errors.quality && (
										<div className='error-message'>
											{errors.quality.message}
										</div>
									)}
								</div>

								<div className='form-group'>
									<label htmlFor='domain'>
										{t("sector")}{' '}
										<span className='required'>*</span>
									</label>
									<CustomInput
										type='text'
										id='domain'
										{...register('domain', {
											required: t("err_message1")+ t("sector"),
											minLength: {
												value: 2,
												message: t("article_m") +t("sector") +t("err_message2"),
											},
											pattern: {
												value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
												message: t("article_m") +t("sector") +t("err_message3"),
											},
										})}
									/>
									{errors.domain && (
										<div className='error-message'>
											{errors.domain.message}
										</div>
									)}
								</div>
							</div>
							<div className='form-group'>
								<label htmlFor='pays'>
									{t("country")} <span className='required'>*</span>
								</label>
								<Controller
									name='pays'
									rules={{
										required:t("country_error_message"),
									}}
									control={control}
									render={({
										field: { onChange, value },
									}) => (
										<Select
											placeholder= {t("country_placeholder")}
											options={options}
											value={options.find(
												(opt) =>
													opt.value === value?.value
											)}
											onChange={(selectedOption) => {
												onChange(selectedOption)
											}}
											styles={{
												control: (base, state) => ({
													...base,
													height: 50,
													minHeight: 50,
													border: 'none',
													borderRadius: '0.5rem',
													fontFamily: 'Montserrat',
												}),
											}}
										/>
									)}
								/>

								{errors.pays && (
									<div className='error-message'>
										{errors.pays.message}
									</div>
								)}
							</div>
							<div className='form-group'>
								<label htmlFor='address'>
									{t("address")} <span className='required'>*</span>
								</label>
								<CustomInput
									type='text'
									id='address'
									{...register('address', {
										required:t("err_message1")+ t("address"),
										minLength: {
											value: 3,
											message:t("article_elided") +t("address") +t("err_message2"),
										},
										pattern: {
											value: /^[A-Za-zÀ-ÿ0-9\s',.\-/()°]+$/,
											message: t("article_elided") +t("address") +t("err_message3"),
										},
									})}
								/>
								{errors.address && (
									<div className='error-message'>
										{errors.address.message}
									</div>
								)}
							</div>
							<div className='form-group'>
								<label htmlFor='city'>
									{t("city")} <span className='required'>*</span>
								</label>
								<CustomInput
									type='text'
									id='city'
									{...register('city', {
										required: t("err_message1")+ t("city"),
										minLength: {
											value: 3,
											message:t("article_f") +t("city") +t("err_message2"),
										},
										pattern: {
											value: /^.+$/,
											message: t("article_f") +t("ville") +t("err_message3"),
										},
									})}
								/>
								{errors.city && (
									<div className='error-message'>
										{errors.city.message}
									</div>
								)}
							</div>
							<div className='form-group'>
								<label htmlFor='postalCode'>
								{t("zip_code")}{' '}
									<span className='required'>*</span>
								</label>
								<CustomInput
									type='text'
									id='postalCode'
									{...register('postalCode', {
										required: t("err_message1")+ t("zip_code"),
										pattern: {
											value: /^\d{5}$/,
											message: t("zip_code_err_message"),
										},
									})}
								/>
								{errors.postalCode && (
									<div className='error-message'>
										{errors.postalCode.message}
									</div>
								)}
							</div>
							<div className='form-row'>
								<div className='form-group'>
									<label htmlFor='phone'>
									{t("contact_us_formulair_item2")}{' '}
										<span className='required'>*</span>
									</label>

									<Controller
										name='phone'
										control={control}
										rules={{
											required:t("err_message1")+ t("contact_us_formulair_item2"),
											validate: validatePhoneNumber,
										}}
										render={({ field }) => (
											<PhoneInput
												country={'fr'}
												value={field.value}
												onChange={(value, data) => {
													field.onChange(value)
												}}
												inputStyle={{
													paddingRight: '1.5rem',
													paddingTop: '1.5rem',
													paddingBottom: '1.5rem',
													borderRadius: '0.5rem',
													border: 'none',
													fontFamily: 'Montserrat',
													color: '#858ea8',
													flex: '1',
													display: 'flex',
													width: '100%',
												}}
												buttonStyle={{
													borderRadius: '0.5rem',
													border: 'none',
													fontFamily: 'Montserrat',
													color: '#858ea8',
													flex: '1',
													display: 'flex',
												}}
											/>
										)}
									/>
									{errors.phone && (
										<div className='error-message'>
											{errors.phone.message}
										</div>
									)}
								</div>

								<div className='form-group'>
									<label htmlFor='email'>
										 {t("email")} {' '}
										<span className='required'>*</span>
									</label>
									<CustomInput
										type='text'
										id='email'
										{...register('email', {
											required:t("err_message1")+ t("email"),
											pattern: {
												value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
												message: t("email_err_message"),
											},
										})}
									/>
									{errors.email && (
										<div className='error-message'>
											{errors.email.message}
										</div>
									)}
								</div>
							</div>
							<div className='form-row'>
								<div className='form-group'>
									<label htmlFor='password'>
										 {t("mdp")} {' '}
										<span className='required'>*</span>
									</label>
									<CustomInput
										type='password'
										id='password'
										{...register('password', {
											required:t("err_message1")+ t("mdp"),
											minLength: {
												value: 8,
												message:t("mdp_err_message"),
											},
										})}
									/>
									{errors.password && (
										<div className='error-message'>
											{errors.password.message}
										</div>
									)}
								</div>

								<div className='form-group'>
									<label htmlFor='password_verification'>
										 {t("confirm_mdp")} {' '}
										<span className='required'>*</span>
									</label>
									<CustomInput
										type='password'
										id='password_verification'
										{...register('password_verification', {
											required:t("err_message1")+ t("mdp"),
											minLength: {
												value: 8,
												message:t("mdp_err_message"),
											},
										})}
									/>
									{errors.password_verification && (
										<div className='error-message'>
											{
												errors.password_verification
													.message
											}
										</div>
									)}
								</div>
							</div>
							<div className='upload-section'>
								<div className='upload-header'>
									<span>Logo(PNG {t("or")} JPG)</span>
									<span className='optional-text'>
										({t("optional")})
									</span>
								</div>
								<Controller
									name='logo'
									control={control}
									render={({ field }) => (
										<MemoizedUploadFile
											name={field.name}
											accept={'.jpg, .png'}
		
											setValue={setValue}
											{...field}
										/>
									)}
								/>
							</div>
							<div className='upload-section'>
								<div className='upload-header'>
									<span>KBIS (PDF)</span>
									<span className='optional-text'>
										({t("optional")})
									</span>
								</div>

								<Controller
									name='kbis'
									control={control}
									render={({ field }) => (
										<MemoizedUploadFile
											name={field.name}
											accept={'.pdf'}
											setValue={setValue}
											{...field}
										/>
									)}
								/>
							</div>
							<div className='upload-section'>
								<div className='upload-header'>
									<span>
										{t("id_card")} (PDF){' '}
										<span className='required'>*</span>
									</span>
								</div>

								<Controller
									name='piece_identite'
									control={control}
									rules={{
										required:t("id_card_err_message"),
									}}
									render={({ field }) => (
										<>
											<MemoizedUploadFile
												name={field.name}
												accept={'.pdf'}
												setValue={setValue}
												{...field}
											/>
											{errors?.piece_identite && (
												<span className='error-message'>
													{
														errors?.piece_identite
															.message
													}
												</span>
											)}
										</>
									)}
								/>
							</div>
						</FormSectionCard>
						<div className='terms-container'>
							<input
								type='checkbox'
								id='acceptTerms'
								{...register('acceptTerms', {
									required: t("terms_and_conditions_err_message"),
								})}
							/>
							<label
								htmlFor='acceptTerms'
								className='terms-label'
							>
								{t("accept_terms_and_conditions")}{' '}
								<Link
									to='/cgv'
									target='_blank'
									className='terms-link'
								>
									{t("terms_and_conditions")}
								</Link>
							</label>
						</div>

						{errors.acceptTerms && (
							<div className='error-message terms-error'>
								{errors.acceptTerms.message}
							</div>
						)}
						<SubmitButtonContainer>
							<SubmitButton type='submit' disabled={loading}>
								{loading ? (
									<div className='loader'></div>
								) : (
									t("sign_up")
								)}
							</SubmitButton>
						</SubmitButtonContainer>
					</form>
				</div>
			</div>

			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => {}}
				style={{
					overlay: {
						position: 'fixed',
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'rgba(0, 0, 0, 0.45)',
						zIndex: 1001
					},
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						marginRight: '-50%',
						transform: 'translate(-50%, -50%)',
						borderRadius: 19,
						zIndex: 1002,
						width : isSmallScreen ? '90%' : '70%'
					},
				}}
				contentLabel='Example Modal'
			>
				<div className='modal-content'>
					<GradientText style={{fontSize: isSmallScreen ? '1.5rem' : '2.5rem'}}>{t("model_title1").toUpperCase()}</GradientText>

					<div className='modal-message'>
						{t("model_msg5")} 
						<br />
						{t("model_msg6")}
						
					</div>

					<button
						onClick={() => {
							history.push('/')
						}}
						className='modal-button'
					>
						OK
					</button>
				</div>
			</Modal>
			<Footer />
		</>
	)
}

export default SignUp
